import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
const reassurances = ['Download istantaneo dopo il pagamento', 'Un solo pagamento, nessun abbonamento', 'Accesso a vita con aggiornamenti inclusi', 'Garanzia di 7 giorni, senza domande'];
export function Offer() {
  return <section id="offer" className="relative w-full overflow-hidden bg-ink px-5 py-20 sm:py-28" data-id="element-163" data-mp="tybkrmu3pbg0">
      <div className="bg-stripes absolute inset-0" aria-hidden="true" data-id="element-164" data-mp="p0a418k5do7p" />
      <div className="relative mx-auto max-w-xl" data-id="element-165" data-mp="p24roumszufh">
        <Reveal className="text-center" data-id="element-166" data-mp="13y2f9oinvqg3">
          <span className="inline-flex rounded-full bg-volt px-4 py-1.5 font-display text-xs tracking-[0.16em] text-ink" data-id="element-167" data-mp="13uy8cjdtaglq">
            Offerta speciale di lancio
          </span>
          <h2 className="balance mt-6 font-display text-[2.4rem] leading-[0.98] text-white sm:text-[3.4rem]" data-id="element-168" data-mp="2famw3cyw3jnl">
            Kit Inglese Pronto™ <span className="text-brand" data-id="element-169" data-mp="pk7fxlpl6l9g">completo</span>
          </h2>
        </Reveal>

        <Reveal delay={0.06} data-id="element-170" data-mp="pmbkm5vb7oas">
          <div className="relative mt-12 rounded-3xl border-2 border-ink bg-white px-6 pb-8 pt-12 shadow-lift sm:px-9" data-id="element-171" data-mp="uishbogkrazh">
            <span className="absolute -top-4 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full border-2 border-ink bg-brand px-5 py-1.5 font-display text-xs tracking-[0.14em] text-white" data-id="element-172" data-mp="zjg5m2df5dq0">
              6 volumi + 5 bonus
            </span>

            <dl data-id="element-173" data-mp="6rwgy2y1z7gm">
              {offerRows.map(row => <div key={row.label} className="flex items-start justify-between gap-4 border-b border-ink/10 py-4" data-id="element-174" data-mp="bs10k1u9cib2">
                  <dt className="text-base leading-snug text-ink/75" data-id="element-175" data-mp="ftm7l6k422dc">
                    {row.label}
                  </dt>
                  <dd className="shrink-0 font-bold text-ink/40 line-through" data-id="element-176" data-mp="kmfdvyv89irj">
                    {row.value}
                  </dd>
                </div>)}
              <div className="flex items-center justify-between gap-4 border-b-2 border-ink py-4" data-id="element-177" data-mp="3o9fq1qy05nx1">
                <dt className="font-display text-lg text-ink" data-id="element-178" data-mp="veyyqji1b0y8">Valore totale</dt>
                <dd className="shrink-0 font-display text-lg text-ink/40 line-through" data-id="element-179" data-mp="qgxg1zoit3na">
                  €110
                </dd>
              </div>
            </dl>

            <p className="mt-8 text-center font-display text-sm tracking-[0.18em] text-brand" data-id="element-180" data-mp="157mudaxa2yvd">
              Solo per oggi
            </p>
            <p className="mt-2 text-center" data-id="element-181" data-mp="cgczzb9zplxh">
              <span className="font-display text-[4.5rem] leading-none text-ink sm:text-[5.5rem]" data-id="element-182" data-mp="ch4vkm3l7jnr">
                €19
              </span>
              <span className="mt-2 block text-sm font-bold uppercase tracking-[0.16em] text-ink/50" data-id="element-183" data-mp="lhb5jy02u1i6">
                Pagamento unico · Download istantaneo
              </span>
            </p>

            <CtaButton label="Voglio il mio Kit ora" className="mt-8 w-full" data-id="element-184" data-mp="1wwpzsu0wif9l" />

            

            <ul className="mt-6 space-y-2.5" data-id="element-185" data-mp="1sv4srpb1sv7b">
              {reassurances.map(item => <li key={item} className="flex items-center gap-2.5 text-sm font-semibold text-ink/70" data-id="element-186" data-mp="1suv1zzi6ik0k">
                  <span className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-volt" data-id="element-187" data-mp="20gqhrp1uas69">
                    <CheckIcon className="h-3 w-3 text-ink" aria-hidden="true" strokeWidth={3} data-id="element-188" data-mp="25bdz93yfembc" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}